export enum InternalServerErrorCode {
  NotAuthenticated = 1001,
  ACCOUNT_PLAN_EXPIRED = 2001,
  PREMIUM_FEATURE_ERROR = 2002,
}
